import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { schedulingContext } from './SchedulingContext';


let Scheduling = () => {
    let service = useContext(schedulingContext);

    return (
        <>
            <PageHeader pageTitle={"Pianificazione"} />
            <Filter />

            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default Scheduling;